import React from 'react';
import { FormattedMessage } from 'react-intl';
import css from './FilterSidebar.module.css';
import classNames from 'classnames';
const FilterSectionHeader = ({ handleClear, titleId, isBlackBgFilter }) => {
  return (
    <div className={classNames(isBlackBgFilter ? css.blackBgFilter : null, css.sectionHeader)}>
      <h3>
        <FormattedMessage id={titleId} />
      </h3>
      <button className={css.clearButton} onClick={handleClear}>
        <FormattedMessage id="FilterCategories.clear" />
      </button>
    </div>
  );
};

export default FilterSectionHeader;
